/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Servers_EmptyInputs */



/**
* | output |
* | --- |
* | "No MCP servers configured. Add one above to extend AI capabilities with external tools." |
*
* @param {Mcp_Servers_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_empty = /** @type {((inputs?: Mcp_Servers_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine MCP-Server konfiguriert. Fügen Sie einen hinzu, um die KI mit externen Tools zu erweitern.")
	return /** @type {LocalizedString} */ ("No MCP servers configured. Add one above to extend AI capabilities with external tools.")
});